<div class="login-wrapper" [ngClass]="{'jump-splash-page': isJumpRoute}" [style.background-image]="'url(' + loginBgImage + ')'">

  <div class="login-card">
    <div class="login-brand">
      @if (!isJumpRoute) {
        <img src="/uploads/system_images/yeeHRologo.png" alt="YeeHRo Logo" class="brand-logo" />
      }
      @if (isJumpRoute) {
        <img src="/uploads/system_images/jumpHirelogo.png" alt="JumpHire Logo" class="brand-logo" />
      }
    </div>

    <h1 class="login-title">Welcome back</h1>
    <p class="login-subtitle">Sign in to your account</p>

    @if (errorMessage) {
      <div class="login-error">
        <span class="error-icon">!</span>
        <span>{{ errorMessage }}</span>
      </div>
    }

    @if (isLoading) {
      <div class="login-spinner">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      <form novalidate class="login-form" (ngSubmit)="login()">
        <div class="form-field">
          <label for="emailInput">Email</label>
          <input id="emailInput" type="text" [(ngModel)]="user.email" name="email" placeholder="you@company.com" autocomplete="email" />
        </div>
        <div class="form-field">
          <label for="passwordInput">Password</label>
          <input id="passwordInput" type="password" [(ngModel)]="user.password" name="password" placeholder="Enter your password" autocomplete="current-password" />
        </div>
        <div class="form-options">
          <mat-checkbox color="primary" [(ngModel)]="rememberMe" name="rememberMe">Remember me</mat-checkbox>
          <a class="forgot-link" [routerLink]="['/forgot-password']">Forgot password?</a>
        </div>
        <button type="submit" [disabled]="!user.email || !user.password" class="login-btn">
          Sign In
        </button>
      </form>
    }
  </div>

</div>